import React from "react";
import AddShipments from "../../../Features/Forms/Shipment/Add";

const Add = () => {
  return (
    <div>
      <AddShipments />
    </div>
  );
};

export default Add;
